import { QueryStringInput } from '@hello-aria/query-string'
import { Repayment } from '../../../shared/models/repaymentModel'
import { makaluApi } from '../../../shared/utils/makaluApiClient'

import { toListQuery, type Page } from '@hello-aria/makalu-api-client'
import { isNil } from 'lodash'
import { handlePrivateEndpointCompanyFilter, handleHttpError } from '../../../shared/utils/queryUtils'
import { mapSort } from '@/shared/utils/sortUtils'
import { mapRepayment } from '@/shared/utils/repaymentUtils'

export const listRepayments = async (
    companyId: string,
    query?: QueryStringInput,
    signal?: AbortSignal
): Promise<Page<Repayment>> => {
    try {
        const updatedQuery = handlePrivateEndpointCompanyFilter(companyId, query)

        const page = await makaluApi.listPage('/private/repayments', {
            params: {
                query: toListQuery({
                    ...updatedQuery,
                    // The route answers the credit worker shape unless `useLegacy` is false.
                    params: { ...updatedQuery.params, useLegacy: 'false' },
                    sorts: mapSort(updatedQuery?.sorts, {
                        usage: 'api'
                    })
                })
            },
            signal
        })

        return { ...page, body: page.body.map(mapRepayment) }
    } catch (error) {
        return handleHttpError('listRepayments', error)
    }
}

export const getRepayment = async (companyId: string, id: string | undefined): Promise<Repayment | undefined> => {
    if (isNil(id)) return

    try {
        const repayment = await makaluApi.GET('/companies/{companyId}/repayments/{repaymentId}', {
            params: { path: { companyId, repaymentId: id } }
        })
        return mapRepayment(repayment)
    } catch (error) {
        return handleHttpError('getRepayment', error)
    }
}
